<input class="micr-font" matInput [formControl]="formControl" [formlyAttributes]="field" pattern="[0-9a-d]*"
	micrFormat [maxlength]="props?.maxLength" [readonly]="props?.readonly || props?.disabled" />
<div *ngIf="!props?.hideMicrKey" class="micr-key">
	Key:
	a = <span class="micr-font">a</span>
	b = <span class="micr-font">b</span>
	c = <span class="micr-font">c</span>
	d = <span class="micr-font">d</span>
</div>
